import React, { useState } from 'react';

import { notification } from 'antd';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import { useWebsites } from '@hooks/API/UseWebsites';

import ModelDetailsBooksPublicationsDrawer from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/ModelDetailsBooksPublicationsDrawer';
import { NwButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import PlaylistPublishedWebsitesList from '@components/MediaDrawer/PlaylistPublishedWebsitesList';
import { getPublishedBookItemKey } from '@components/MediaDrawer/publishedBooks.utils';
import { usePlaylistPublishedWebsites } from '@components/MediaDrawer/usePlaylistPublishedWebsites';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const MediaWebsites = ({ book, onPublishBook }) => {
    const { data: websiteData } = useWebsites();
    const [isPublicationsDrawerOpen, setIsPublicationsDrawerOpen] = useState(false);
    const [removingPublicationKey, setRemovingPublicationKey] = useState(null);
    const { linkedSections, loading, unlinkPublication } = usePlaylistPublishedWebsites({
        book,
        websiteData,
    });
    const modelName = book?.ContactID ? getContactName(book.ContactID) : 'Model';

    const handlePublishBook = () => {
        if (websiteData && websiteData.length > 0) {
            onPublishBook(book);
        } else {
            notification.warning({
                message: 'No Websites Configured',
                description:
                    "There are no websites configured in the management section. Sorry, this book can't be published",
                style: { zIndex: 1050 },
            });
        }
    };

    const handleOpenPublicationsDrawer = () => {
        setIsPublicationsDrawerOpen(true);
    };

    const handleClosePublicationsDrawer = () => {
        setIsPublicationsDrawerOpen(false);
    };

    const handleDrawerRemovePublication = async (item) => {
        const publicationKey = getPublishedBookItemKey(item);
        setRemovingPublicationKey(publicationKey);

        try {
            const didUnlink = await unlinkPublication({
                ...item,
                websiteCode: item.WebsiteCode,
                divisionCode: item.DivisionCode,
                playlistID: item.Playlist?.ID,
                contactID: item.Playlist?.ContactID,
            });
            return didUnlink;
        } finally {
            setRemovingPublicationKey(null);
        }
    };

    return (
        <>
            <NwCard
                icon={byPrefixAndName.fasl['cloud-arrow-up']}
                title="Websites"
                titleAction={
                    <NwButton
                        minimal
                        icon={byPrefixAndName.fass['expand-wide']}
                        size="small"
                        onClick={handleOpenPublicationsDrawer}
                    />
                }
                extra={
                    <NwButton
                        icon={byPrefixAndName.fasl['pen']}
                        ghost
                        size="small"
                        label="edit"
                        onClick={handlePublishBook}
                    />
                }
            >
                <PlaylistPublishedWebsitesList
                    linkedSections={linkedSections}
                    loading={loading}
                    onUnlink={unlinkPublication}
                />
            </NwCard>
            {isPublicationsDrawerOpen && (
                <ModelDetailsBooksPublicationsDrawer
                    contactID={book?.ContactID}
                    modelName={modelName}
                    onClose={handleClosePublicationsDrawer}
                    onRemovePublication={handleDrawerRemovePublication}
                    removingPublicationKey={removingPublicationKey}
                    websiteData={websiteData || []}
                />
            )}
        </>
    );
};

export default MediaWebsites;
